import { __ } from '@wordpress/i18n';
import { registerBlockType } from '@wordpress/blocks';
import icons from '../src/icons';

// Header Blocks.
import { edit as editHeader1, save as saveHeader1 } from './block-header/header-1';
import { edit as editHeader2, save as saveHeader2 } from './block-header/header-2';
import { edit as editHeader3, save as saveHeader3 } from './block-header/header-3';
import { edit as editMegaMenu1, save as saveMegaMenu1 } from './block-header/mega-menu-1';
import { edit as editMegaMenu2, save as saveMegaMenu2 } from './block-header/mega-menu-2';
import { edit as editMegaMenu3, save as saveMegaMenu3 } from './block-header/mega-menu-3';
import { edit as editMegaMenu4, save as saveMegaMenu4 } from './block-header/mega-menu-4';
import { edit as editNoticeBar1, save as saveNoticeBar1 } from './block-header/notice-bar-1';

// Footer Blocks.
import { edit as editFooter1, save as saveFooter1 } from './block-footer/footer-1';
import { edit as editFooter2, save as saveFooter2 } from './block-footer/footer-2';
import { edit as editFooter3, save as saveFooter3 } from './block-footer/footer-3';

// Others
import { edit as editSalesNotify1, save as saveSalesNotify1 } from './block-footer/sales-notify-1';
import { edit as editIconList, save as saveIconList } from './icon-list';
import { edit as editFaIcons, save as saveFaIcons } from './fa-icons';
import { edit as editCountdownTimer, save as saveCountdownTimer } from './countdown-timer';
import { edit as editPopUp, save as savePopUp } from './pop-up';

const blockSettings = [
    {
        name: 'hfc-blocks/header-1',
        title: __('Header 1'),
        description: __('This Block showing Header template - 1.'),
        category: 'hfc-block-cat-header',
        icon: icons.header1,
        keywords: [ __( 'header' ), __( 'navigation' ), __( 'logo' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editHeader1,
        save: saveHeader1,
    },
    {
        name: 'hfc-blocks/header-2',
        title: __('Header 2'),
        description: __('This Block showing Header template - 2.'),
        category: 'hfc-block-cat-header',
        icon: icons.header2,
        keywords: [ __( 'header' ), __( 'navigation' ), __( 'logo' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editHeader2,
        save: saveHeader2,
    },
    {
        name: 'hfc-blocks/header-3',
        title: __('Header 3'),
        description: __('This Block showing Header template - 1.'),
        category: 'hfc-block-cat-header',
        icon: icons.header3,
        keywords: [ __( 'header' ), __( 'navigation' ), __( 'logo' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editHeader3,
        save: saveHeader3,
    },
    {
        name: 'hfc-blocks/mega-menu-1',
        title: __('Mega Menu 1'),
        description: __('This Block showing mega menu after Header.'),
        category: 'hfc-block-cat-header',
        icon: icons.megamenu1,
        keywords: [ __( 'header' ), __( 'navigation' ), __( 'mega' ), __( 'menu' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editMegaMenu1,
        save: saveMegaMenu1,
    },
    {
        name: 'hfc-blocks/mega-menu-2',
        title: __('Mega Menu 2'),
        description: __('This Block showing mega menu after Header.'),
        category: 'hfc-block-cat-header',
        icon: icons.megamenu1,
        keywords: [ __( 'header' ), __( 'navigation' ), __( 'mega' ), __( 'menu' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editMegaMenu2,
        save: saveMegaMenu2,
    },
    {
        name: 'hfc-blocks/mega-menu-3',
        title: __('Mega Menu 3'),
        description: __('This Block showing mega menu after Header.'),
        category: 'hfc-block-cat-header',
        icon: icons.megamenu1,
        keywords: [ __( 'header' ), __( 'navigation' ), __( 'mega' ), __( 'menu' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editMegaMenu3,
        save: saveMegaMenu3,
    },
    {
        name: 'hfc-blocks/mega-menu-4',
        title: __('Mega Menu 4'),
        description: __('This Block showing mega menu after Header.'),
        category: 'hfc-block-cat-header',
        icon: icons.megamenu1,
        keywords: [ __( 'header' ), __( 'navigation' ), __( 'mega' ), __( 'menu' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editMegaMenu4,
        save: saveMegaMenu4,
    },
    {
        name: 'hfc-blocks/notice-bar-1',
        title: __('Notice Bar'),
        description: __('This Block showing mega menu after Header.'),
        category: 'hfc-block-cat-header',
        icon: icons.noticeBar1,
        keywords: [ __( 'header' ), __( 'navigation' ), __( 'mega' ), __( 'menu' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editNoticeBar1,
        save: saveNoticeBar1,
    },
    {
        name: 'hfc-blocks/footer-1',
        title: __('Footer 1'),
        description: __('This Block showing Footer template - 1.'),
        category: 'hfc-block-cat-footer',
        icon: icons.footer1,
        keywords: [ __( 'footer' ), __( 'navigation' ), __( 'logo' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editFooter1,
        save: saveFooter1,
    },
    {
        name: 'hfc-blocks/footer-2',
        title: __('Footer 2'),
        description: __('This Block showing Footer template - 2.'),
        category: 'hfc-block-cat-footer',
        icon: icons.footer2,
        keywords: [ __( 'footer' ), __( 'navigation' ), __( 'logo' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editFooter2,
        save: saveFooter2,
    },
    {
        name: 'hfc-blocks/footer-3',
        title: __('Footer 3'),
        description: __('This Block showing Footer template - 3.'),
        category: 'hfc-block-cat-footer',
        icon: icons.footer3,
        keywords: [ __( 'footer' ), __( 'navigation' ), __( 'logo' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editFooter3,
        save: saveFooter3,
    },
    {
        name: 'hfc-blocks/sales-notify-1',
        title: __('Sales Notify'),
        description: __('This Block showing Footer template - 3.'),
        category: 'hfc-block-cat-footer',
        icon: icons.salesNotify1,
        keywords: [ __( 'footer' ), __( 'navigation' ), __( 'logo' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editSalesNotify1,
        save: saveSalesNotify1,
    },
    {
        name: 'hfc-blocks/icon-list',
        title: __('Icon List'),
        description: __('This Block showing Footer template - 3.'),
        category: 'hfc-block-cat-helper',
        icon: icons.IconList,
        keywords: [ __( 'footer' ), __( 'navigation' ), __( 'icon' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editIconList,
        save: saveIconList,
    },
    {
        name: 'hfc-blocks/fa-icons',
        title: __('FontAwesome Icons'),
        description: __('This Block showing Font Awesome Icons.'),
        category: 'hfc-block-cat-helper',
        icon: icons.FawesomeIcon,
        keywords: [ __( 'footer' ), __( 'navigation' ), __( 'icon' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editFaIcons,
        save: saveFaIcons,
    },
    {
        name: 'hfc-blocks/countdown-timer',
        title: __('Countdown Timer'),
        description: __('This Block showing Countdown Timer.'),
        category: 'hfc-block-cat-helper',
        icon: icons.CdTimer,
        keywords: [ __( 'footer' ), __( 'navigation' ), __( 'icon' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editCountdownTimer,
        save: saveCountdownTimer,
    },
    {
        name: 'hfc-blocks/pop-up',
        title: __('pop-up'),
        description: __('This Block showing pop-up.'),
        category: 'hfc-block-cat-helper',
        icon: icons.PopUp,
        keywords: [ __( 'footer' ), __( 'navigation' ), __( 'icon' ), __( 'list' ) ],
        example: {
            attributes: {
                author: 'Forhad',
            },
        },
        edit: editPopUp,
        save: savePopUp,
    }
];

blockSettings.forEach((block) => {
    registerBlockType(block.name, block);
});